import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import { Field } from 'redux-form';
import { compose } from 'recompose';
import { AsteriskDecorated, alignedQuestion } from '@nextiva/engagement-ui';
import { formatValidationTypeList, debouncedReduxForm } from 'sharedParts';

import FormTextFieldWithStyleInline from 'styling/components/FormTextFieldWithStyleInline';
import StylingToCSSLabelText from 'styling/hocs/StylingToCSS/StylingToCSSLabelText';
import propTypeBlockStyling from 'styling/config/editorBlock/PropTypes/blockStyling';
import propTypeStyleLabel from 'styling/config/editorBlock/PropTypes/styleLabel';
import sanitizeInputNodeValue from 'utils/sanitizeInputNodeValue';

import generateCharactersRemainingTip from '../utils/generateCharactersRemainingTip';
import styles from './RespondentInfoQuestionForm.scss';
import withTakerValidator from '../hoc/withTakerValidator';

class RespondentInfoQuestionForm extends Component {
  static propTypes = {
    block: PropTypes.shape({
      required: PropTypes.bool,
      label: PropTypes.string,
      maximumCharacters: PropTypes.number,
      formatValidationType: PropTypes.oneOf(
        Object.keys(formatValidationTypeList),
      ),
    }).isRequired,
    readOnly: PropTypes.bool,
    e2e: PropTypes.string,
    handleSubmit: PropTypes.func,
    flushSubmit: PropTypes.func,
    styleLabel: propTypeStyleLabel,
    styling: propTypeBlockStyling,
    validator: PropTypes.arrayOf(PropTypes.func),
  };

  handleFieldChange = e => {
    if (e.target.value.length > this.props.block.maximumCharacters) {
      e.preventDefault();
    }
  };

  renderField = ({
    maximumCharacters,
    remaining,
    label,
    readOnly,
    e2e,
    ...field
  }) => (
    <div className={styles.container} data-e2e="respondent-info-question-form">
      <FormTextFieldWithStyleInline
        labelAlign="out"
        className={styles.field}
        containerClassName={styles.input}
        tipClassName={cx(styles.tip, styles.up)}
        readOnly={readOnly}
        tip={
          remaining && maximumCharacters
            ? generateCharactersRemainingTip(
                field.input.value.length,
                maximumCharacters,
              )
            : null
        }
        label={label}
        maxLength={maximumCharacters}
        {...field}
        data-e2e={e2e}
      />
    </div>
  );

  render() {
    const {
      block: { required, label, remaining, maximumCharacters },
      readOnly,
      e2e,
      flushSubmit,
      validator,
      styleLabel,
      styling,
    } = this.props;

    const labelBody = (
      <AsteriskDecorated required={required}>
        <span style={styleLabel}>{label}</span>
      </AsteriskDecorated>
    );

    return (
      <Field
        name="value"
        component={this.renderField}
        onChange={this.handleFieldChange}
        validate={validator}
        onBlur={flushSubmit}
        normalize={sanitizeInputNodeValue}
        props={{
          readOnly,
          remaining,
          maximumCharacters,
          e2e,
          label: labelBody,
          styling,
        }}
      />
    );
  }
}

export default compose(
  debouncedReduxForm({
    debounceOptions: { leading: false },
    form: 'CustomerInformationQuestionForm',
    isAutoSubmit: true,
  }),
  alignedQuestion,
  withTakerValidator,
  StylingToCSSLabelText,
)(RespondentInfoQuestionForm);
